import { useEffect, type ReactNode } from "react";
import styles from "./BaseModal.module.css";

export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL

type BaseModalProps = {
  open: boolean;
  title: string;
  subtitle?: string;
  children: ReactNode;
  onCancel: () => void;
};

export default function BaseModal({
  open,
  title,
  subtitle,
  children,
  onCancel,
}: BaseModalProps) {
  useEffect(() => {
    if (!open) return;

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        onCancel();
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>

        {children}
      </div>
    </div>
  );
}
